import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var VideoRecorder = function VideoRecorder(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M22 8.9314c0-.6059 0-.9087-.1198-1.049a.5.5 0 0 0-.4194-.1738c-.1839.0145-.3981.2287-.8265.657L17 12l3.6343 3.6343c.4284.4284.6426.6426.8265.6571a.5.5 0 0 0 .4194-.1738C22 15.9774 22 15.6744 22 15.0686zM2 9.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 5 5.1198 5 6.8 5h5.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C17 7.2798 17 8.1198 17 9.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C14.7202 19 13.8802 19 12.2 19H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 16.7202 2 15.8802 2 14.2z"
    })
  }));
};
export default VideoRecorder;